import { GardenPhase, gardenPhase } from "@/lib/gardenStatus";

interface Props {
  phase: GardenPhase;
  /** Optional override for the visible text (defaults to the Garden label). */
  label?: string;
  size?: "sm" | "md";
}

/**
 * The ONLY status badge component in the admin surface.
 * Uses the five-phase Garden vocabulary. See src/lib/gardenStatus.ts.
 */
export function GardenStatusBadge({ phase, label, size = "sm" }: Props) {
  const meta = gardenPhase(phase);
  const sizing =
    size === "md" ? "text-xs px-2.5 py-1" : "text-[11px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${meta.tone} ${sizing} font-medium whitespace-nowrap`}
      title={meta.description}
    >
      <span aria-hidden>{meta.emoji}</span>
      <span>{label ?? meta.label}</span>
    </span>
  );
}
